import {Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf} from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  FormControl,
  ValidationErrors,
  Validator
} from '@angular/forms';

@Component({
  selector: 'app-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => FormInputComponent),
      multi: true
    }
  ]
})
export class FormInputComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() label = '';
  @Input() name: string = 'input';
  @Input() placeholder = '';
  @Input() type: string = 'text';
  @Input() required = false;
  @Input() pattern: string = '';
  @Input() min?: number;
  @Input() max?: number;
  @Input() readonly: boolean = false;
  @Input() autocomplete: string = 'on';
  @Input() formControlName!: string;
  private _value = '';
  passwordField: boolean = false;
  control: any;
  errors: string [] = [];
  public onChange: any = Function.prototype;
  public onTouched: any = Function.prototype;

  constructor(
    @Optional() @Host() @SkipSelf() private controlContainer: ControlContainer
  ) {
  }

  ngOnInit() {
    if (this.controlContainer) {
      const form = this.controlContainer.control as FormGroup;
      if (form) {
        this.control = form.get(this.name);

        // @LOUIS -> Logiquement on devrait utiliser formControlName
        // this.control = form.get(this.formControlName);
        // Je vais finaliser les tests. 
      }
    }

    this.passwordField = this.type === 'password';
  }

  get value(): any {
    return this._value;
  }

  set value(v: any) {
    if (v !== this._value && v !== undefined) {
      this._value = v;
      this.onChange(v);
      this.control.setValue(v);
      this.runValidation();
    }
  }

  // ControlValueAccessor interface impl
  writeValue(value: any) {
    if (value !== undefined && value !== this._value) {
      this._value = value;
      this.control.setValue(value);
      this.runValidation();
    }
  }

  // ControlValueAccessor interface impl
  public registerOnChange(fn: (_: any) => {}): void {
    this.onChange = fn;
  }

  // ControlValueAccessor interface impl
  public registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }

  public validate(c: FormControl) {
    return c.errors;
  }

  public getError(errors: ValidationErrors | null): string[] {
    return errors == null ? [] : Object.keys(errors);
  }

  toggleVisibility() {
    if (this.type === "password") {
      this.type = "text";
    } else {
      this.type = "password";
    }
  }

  onInput(event: any) {
    this.value = event.target.value;
  }

  runValidation() {
    const validators = this.control.validator ? [this.control.validator] : [];
    let validationErrors: ValidationErrors = {};
    validators.forEach(validator => {
      const result = validator(new FormControl(this._value));
      validationErrors = {...validationErrors, ...result};
    });
    this.errors = Object.keys(validationErrors);
  }
}
